// Sohbeti su an kimin yuruttugunu (insan temsilci / AI calisan / chatbot) cozer.
// conversation.status giristen sonra guncellenmedigi icin karar mesaj izlerinden verilir;
// ad ve avatar tek kaynaktan (participants[0]) okunur.

const AI_WORKER = "ai-worker";
const HUMAN = "human";
const CHATBOT = "chatbot";

const HUMAN_MESSAGE_TYPES = ["user", "user-media", "user-location", "user-email", "user-sms"];
const HUMAN_SYSTEM_TYPES = ["user-login", "user-destroy"];

/** Mesaj hangi yurutucuye ait; iz degilse null. */
function handlerOfMessage(m) {
    if (!m) return null;
    const actor = m.actorDetail;
    if (actor && actor.type === AI_WORKER && actor.aiWorkerName) {
        return { type: AI_WORKER, name: actor.aiWorkerName, avatar: actor.aiWorkerAvatar || undefined };
    }
    const type = String(m.messageType || "");
    if (type === "system") return HUMAN_SYSTEM_TYPES.includes(m.systemMessageType) ? { type: HUMAN } : null;
    if (HUMAN_MESSAGE_TYPES.includes(type)) return { type: HUMAN };
    if (type.startsWith(CHATBOT)) return { type: CHATBOT };
    return null;
}

/** Mesajlari sondan basa tarayip en yeni yurutucu izini verir; yoksa null. */
function resolveActiveHandler(messages) {
    const list = Array.isArray(messages) ? messages : [];
    for (let i = list.length - 1; i >= 0; i--) {
        const found = handlerOfMessage(list[i]);
        if (found) return found;
    }
    return null;
}

/** Katilimcinin avatari; chatbot/AI calisan icin ozel avatar yoksa ayarlardaki chatbot avatari. */
function getParticipantAvatar(participant, settings) {
    if (!participant) return null;
    if (participant.gravatar) return participant.gravatar;
    if (participant._id !== CHATBOT) return null;
    const asset = settings && settings.chatbotAvatar;
    if (!asset || !asset.path || !asset.id || !asset.ext) return null;
    return asset.v2Format && asset.cdnUrl ? asset.cdnUrl : `https://static.supsis.live/${asset.path}${asset.id}.${asset.ext}`;
}

module.exports = { HANDLER_TYPES: { AI_WORKER, HUMAN, CHATBOT }, handlerOfMessage, resolveActiveHandler, getParticipantAvatar };



// WEBPACK FOOTER //
// ./src/utils/conversationHandler.js